var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-notification"},_vm._l((_vm.notifications),function(notification){return _c('div',[_c('div',{staticClass:"alert",class:`alert-${notification.cssClass}`,attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.verbose ? notification.message : notification.simpleMessage)+"\n        ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }